<template>
  <div class="reportList">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">
        高阶报告 - 规划报告
      </el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('客户电话', 'Phone')">
        <el-input style="width: 130px;" :placeholder="util.language('请输入完整电话', 'Complete phone number')" v-model="searchParam.accountPhone" clearable />
      </el-form-item>
      <el-form-item :label="util.language('学生姓名', 'Stu Name')">
        <el-input style="width: 130px;" v-model="searchParam.stuName" clearable />
      </el-form-item>
      <el-form-item label="状态">
        <el-select v-model="searchParam.state" placeholder="请选择" style="width: 180px;" clearable>
          <el-option label="生成中" value="INIT" />
          <el-option label="完成" value="FINISH" />
          <el-option label="失败" value="ERROR" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('搜索', 'Search') }}</el-button>
          <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.reportList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <!-- <el-table-column type="selection" width="55" align="center" /> -->
      <el-table-column label="订单编号" width="160" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="accountPhone" label="账号（电话）" width="160" />
      <el-table-column prop="accountNick" label="昵称" width="160" show-overflow-tooltip />
      <el-table-column prop="state" label="状态" width="100" show-overflow-tooltip>
        <template #default="scope">
          <el-text v-if="scope.row.state == 'INIT'">生成中…</el-text>
          <el-text v-if="scope.row.state == 'FINISH'" type="success">完成</el-text>
          <el-text v-if="scope.row.state == 'ERROR'" type="danger">失败</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="stuName" label="学生姓名" show-overflow-tooltip />
      <el-table-column prop="createDatetime" label="提交时间" width="180">
        <template #default="scope">
          <el-text>{{ util.parseTime(scope.row.createDatetime) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="finishDatetime" label="完成时间" width="180">
        <template #default="scope">
          <el-text>{{ util.parseTime(scope.row.finishDatetime) }}</el-text>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="160">
        <template #default="scope">
          <el-button v-if="scope.row.state == 'FINISH'" type="primary" @click="openfile(scope.row.reportFile)">下载报告</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.reportTotal" @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  reportTotal: 0,
  reportList: [],
  menuList: [],
  newPassword: '',
})
const loading = reactive({
  find: false,
})
const show = reactive({
  selected: [],
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 50
  searchParam.accountPhone = ''
  searchParam.stuName = ''
  searchParam.state = null
}
resetSearchParam()

const commitFindList = () => {
  loading.find = true
  api.get('/backend/report/getPage', { params: searchParam }).then(res => {
    data.reportList = res.list
    data.reportTotal = res.total
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const update = (row) => {
  const report = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'reportDetail', report)
  router.push('/reportDetail')
}

const openfile = (url) => {
  window.open(url)
}
</script>

<style lang="less"></style>